export const REPLAN_REQUEST_CHANGES_TEST_ID = "replan-request-changes";
export const REPLAN_REQUEST_IGNORED_CHANGES_TEST_ID = "replan-request-ignored-changes";
export const REPLAN_REQUEST_CHANGE_ADDRESS_TEST_ID = "replan-request-change-address";
